var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaichartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2221 16.6001C18.6667 16.303 19.1334 16.0454 19.6171 15.8288C20.989 15.2144 21.6749 14.9072 22.5875 15.4984C23.5 16.0896 23.5 17.0594 23.5 18.999V20.499C23.5 22.3847 23.5 23.3275 24.0858 23.9133C24.6716 24.499 25.6144 24.499 27.5 24.499H29C30.9396 24.499 31.9094 24.499 32.5006 25.4116C33.0918 26.3241 32.7846 27.0101 32.1702 28.3819C31.9536 28.8656 31.696 29.3324 31.399 29.777C30.3551 31.3392 28.8714 32.5569 27.1355 33.2759C25.3996 33.9949 23.4895 34.1831 21.6466 33.8165C19.8038 33.4499 18.1111 32.5452 16.7825 31.2166C15.4539 29.888 14.5491 28.1952 14.1825 26.3524C13.816 24.5096 14.0041 22.5994 14.7231 20.8635C15.4422 19.1276 16.6598 17.644 18.2221 16.6001Z",
    fill: "#141414"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.446 19.068C32.6342 17.0073 30.9917 15.3648 28.931 14.553C27.3895 13.9457 26 15.3422 26 16.999V20.999C26 21.5513 26.4477 21.999 27 21.999H31C32.6569 21.999 34.0533 20.6096 33.446 19.068Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaichartIcon);
export default __webpack_public_path__ + "static/media/paichartIcon.600f543fb90ae897a7716692177fbb71.svg";
export { ForwardRef as ReactComponent };